var exports = {
  "q": "GuildChatWallpaper.module__layer___bkZPan",
  "S": "GuildChatWallpaper.module__image___bkZPan",
};

module.exports = exports;
